/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RemplacementSearch
 */
export interface RemplacementSearch {
    /**
     * 
     * @type {number}
     * @memberof RemplacementSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof RemplacementSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof RemplacementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RemplacementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RemplacementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RemplacementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RemplacementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RemplacementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RemplacementSearch interface.
 */
export function instanceOfRemplacementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RemplacementSearchFromJSON(json: any): RemplacementSearch {
    return RemplacementSearchFromJSONTyped(json, false);
}

export function RemplacementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemplacementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RemplacementSearchToJSON(value?: RemplacementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateur': value.idFormateur,
        'centre': TextSearchToJSON(value.centre),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

